module.exports = __webpack_public_path__ + "img/icon_01.63100784.svg";